export const DEFAULT_STORE_ID = '1';

export const DEFAULT_CHANNEL = 'LANDING';
